import React, { useContext, useState } from 'react'
import { AppCtx } from '@paytrace/pt-skel/Context'
import { PopupLink } from './PopupWindow'
import Event from '../Event'
import PubSub from '@paytrace/pt-skel/Event/PubSub'
import { useMountUnmount } from '@paytrace/pt-skel/Hooks'
import { DownloadIcon } from './Icons'

type SelectChangeEvent = React.ChangeEvent<HTMLSelectElement>

interface TransactionSectionControlsProp {
  discDataVisible: boolean
  toggleDiscDataVisibility: () => void
  setItemsPerPage: (val: number) => void
  onDownload: (isDetail: boolean) => void
  onShowAll: () => void
  selectedRecords?: Set<number>
  onSelectAllRecords?: (column: string, checked: boolean) => void
  onPrintAll?: () => void
}

export function TransactionSectionControls ({
  discDataVisible,
  toggleDiscDataVisibility,
  setItemsPerPage,
  onDownload,
  onShowAll,
  ...rest
}: TransactionSectionControlsProp) {
  const [disabled, setDisabled] = useState(false)

  const context = useContext(AppCtx)
  const merchantId = context.merchant

  // do not think this is the best way to concatentate transaction ids as a url query
  // but since the link to "receipt.pay" legacy page expects it to be like this need to call
  // the URL like how legacy does it until that page is rewritten.
  const tranxids = Array.from(rest.selectedRecords ?? []).join(',')
  const receiptUrl = `/receipt.pay?tranxid=${tranxids}&id=${merchantId}`

  // can polish up the ux later, just do not want user to continually smash the button
  useMountUnmount(() => {
    PubSub.sub(self, Event.DOWNLOAD_TRANSACTION_HISTORY_REQUEST, async () => {
      setDisabled(true)
    })

    PubSub.sub(self, Event.DOWNLOAD_TRANSACTION_HISTORY_RESPONSE, async () => {
      setDisabled(false)
    })

    return () => {
      PubSub.unsub(self)
    }
  })

  const selectAllRecords = () => {
    if (rest.onSelectAllRecords) {
      rest.onSelectAllRecords('', true)
    }
  }

  const unselectAllRecords = () => {
    if (rest.onSelectAllRecords) {
      rest.onSelectAllRecords('', false)
    }
  }

  const printAllResults = () => {
    if (rest.onPrintAll) {
      rest.onPrintAll()
    }
  }

  return (
    <>
      <div className="controls-row widget-tools">
        <div className="controls-container">
          <label className="control-checkbox-label">
            <input type="checkbox" checked={discDataVisible} onChange={toggleDiscDataVisibility} />
            Show Discretionary Data
          </label>

          <select className="control-select" defaultValue="50" onChange={
            (evt: SelectChangeEvent) => setItemsPerPage(Number(evt.target.value))
          }>
            <option value="10">10</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>

          <div className="btn-group">
            <div className="dropdown">
              <button className="dropdown-btn control-btn" disabled={disabled} onClick={() => onDownload(false)}>
                <i className="fas fa-download"><DownloadIcon /></i> Download
              </button>
              <div className="dropdown-content">
                <button className="control-btn" disabled={disabled} onClick={() => onDownload(true)}>
                  <i className="fas fa-download"><DownloadIcon /></i> Download Details
                </button>
              </div>
            </div>
          </div>

          <button className="control-btn" onClick={onShowAll}>Show All</button>
          <button className="control-btn" onClick={printAllResults}>Print All</button>

          <div className="btn-group">
            <div className="dropdown">
              <PopupLink className="uid-view-receipts control-btn className" href={receiptUrl}>View Receipt(s)</PopupLink>
              <div className="dropdown-content">
                <div className="control-btn" onClick={selectAllRecords}>
                  Select All
                </div>
                <br/>
                <div className="control-btn" onClick={unselectAllRecords}>
                  Select None
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  )
}
